import Model from "../model/model";
import {isObject} from "./isObject.function";

// Merge objects (and Models) recursively, also check for relations containing models and copy and/or merge according to id
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deepMergeObjects(oldObject: any, newObject: any): object {
  if (oldObject === null) {
    return newObject;
  }
  if (newObject === null) {
    return oldObject;
  }
  Object.keys(newObject).forEach((key: string) => {
    //default object keys that can not be merged
    if (["__proto__", "constructor", "prototype"].includes(key)) {
      return;
    }

    // searching relation in object
    if (Array.isArray(newObject[key])) {
      (oldObject[key] as Model[]) = (newObject[key] as Model[]).map((relationItem: Model) => {

        const oldRelation: Model | undefined = (oldObject[key] as Model[])?.find((rel: Model) => relationItem.id !== undefined && rel.id === relationItem.id);

        if (!oldRelation) {
          // item not found in old data
          return relationItem;
        }

        // merge again one relation deeper
        return deepMergeObjects(oldRelation, relationItem) as Model;
      });
    } else if (isObject(newObject[key]) && isObject(oldObject[key])) {
      (oldObject[key] as object) = deepMergeObjects(oldObject[key], newObject[key]) as object;
    } else {
      (oldObject[key] as object) = newObject[key];
    }
  });
  return oldObject;
}
